





























































import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * Daftar observasi Bundle PPI pada satu register — dipakai bersama oleh
 * keempat bundle (VAP/ISK/IAD/IDO). Baris diklik untuk membuka observasi
 * tersebut di form di bawahnya.
 */
@Component
export default class BundleObservasiList extends Vue {
  @Prop({ default: () => [] }) readonly rows!: any[];
  @Prop({ default: null }) readonly selectedId!: number | null;

  /** Persen dihitung atas item yang DINILAI saja (kepatuhan_total dari server). */
  persen(row: any): number {
    const total = row.kepatuhan_total || 0;
    if (!total) return 0;
    return Math.round(((row.kepatuhan_count || 0) / total) * 1000) / 10;
  }

  warna(row: any): string {
    const p = this.persen(row);
    if (p >= 80) return "success";
    if (p >= 50) return "warning";
    return "error";
  }

  formatTanggal(tgl: string): string {
    if (!tgl) return "-";
    // Kolom DATE dari server: "YYYY-MM-DD" (kadang ikut jam bila di-cast).
    const d = new Date(String(tgl).substring(0, 10) + "T00:00:00");
    if (isNaN(d.getTime())) return tgl;
    return d.toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  }

  /** Kolom TIME dari server "HH:MM:SS" → tampil "HH:MM". */
  formatJam(jam: string): string {
    if (!jam) return "-";
    return String(jam).substring(0, 5);
  }
}
